export const getEnsemblTranscripts = (state) =>
  state?.variantResult?.ensembl_transcripts;
export const getRefSeqTranscripts = (state) =>
  state?.variantResult?.refseq_transcripts;
export const getSchema = (state) => state?.schema;
